import { createComponent } from '@carvana/vdp-components';
import classNames from 'classnames';
import React from 'react';

type OwnProps = React.PropsWithoutRef<React.HTMLProps<HTMLDivElement>> & {
  text: string;
  border?: boolean;
  bgColor: string;
  blueText?: boolean;
};

const Wrapper = createComponent('div', {
  className:
    'flex font-bold h-[20px] items-center leading-[16px] px-4 rounded text-[12px] w-fit'
});

const Tag = ({
  bgColor,
  border = false,
  text,
  blueText = false,
  ...props
}: OwnProps) => (
  <Wrapper
    className={classNames(
      { 'border border-grey-3': border },
      { 'text-white': !blueText },
      { 'text-blue-6': blueText },
      bgColor
    )}
    {...props}
  >
    {text}
  </Wrapper>
);

export default Tag;
